<template>
  <qx-card title="客户线路列表">
    <LogRightDialog ref="logRightDialog" busiCode="100022" />
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <!-- <qx-permpisions permpisions>
        <ImportBtn title="客户订单导入" bizCodes="xxxxxx" fileUrl="/file/客户订单导入.xlsx" />
      </qx-permpisions>-->
      <!-- <qx-permpisions permpisions>
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="cityCustomerOrderBO.ajax?cmd=queryPage"
          :params="fullSearchData"
          bizName="客户订单导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions> -->
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'customerLineNo'"
                  @click="toDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '查看',
                    event: () => toDetail(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.customerId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
// import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
// import ImportBtn from 'components/importBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  cityCustomerLineQueryPage,
} from 'api/distribution';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    // ExportBtn,
    // ImportBtn,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'customerLineNo', label: '客户线路编码', fixed: true },
          { prop: 'lineCodeName', label: '线路名称' },
          { prop: 'lineStsName', label: '线路状态' },
          { prop: 'orgName', label: '归属部门' },
          { prop: 'customerName', label: '客户全称' },
          { prop: 'vehicleInfo', label: '车型要求' },
          { prop: 'incomeChargeModeName', label: '收入计费方式' },
          { prop: 'priceUnit', label: '单价' },
          { prop: 'priceEnumName', label: '计价方式' },
          { prop: 'estimateIncome', label: '预估应收' },
          { prop: 'payWayName', label: '结算方式' },
          { prop: 'reciveTimeStr', label: '回单期限' },
          { prop: 'collectionTimeStr', label: '收款期限' },
          { prop: 'tempTypeName', label: '温控要求' },
          { prop: 'remarks', label: '备注说明' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: cityCustomerLineQueryPage,
    toEdit (item) {
      this.jump({
        label: item ? `修改客户线路-${item.customerLineNo}` : '新增客户线路',
        url: `/manage/distribution/customerLine/edit?id=${item ? item.lineId : ''}`,
        full: true,
      });
    },
    toDetail (item) {
      this.jump({
        label: `客户线路详情${item.customerLineNo ? '-' + item.customerLineNo : ''}`,
        url: `/manage/distribution/customerLine/detail?id=${item.lineId}`,
        full: true,
      });
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
